"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConfidentialFileOwner = isConfidentialFileOwner;
const global_assets_sentinel_owner_id_1 = require("./global-assets-sentinel-owner-id");
function isConfidentialFileOwner(ownerId) {
    return ownerId != null && ownerId !== global_assets_sentinel_owner_id_1.GLOBAL_ASSETS_SENTINEL_OWNER_ID;
}
//# sourceMappingURL=file-confidentiality.js.map